const summary = (enhancement) => `${
  enhancement?.data?.occasion
} | ${
  enhancement?.data?.date
} . ${
  enhancement?.data?.time
}
<br>
${
  enhancement?.data?.comment
}
`
const summaryShort = (enhancement) => `${
  enhancement?.data?.date
} ${
  enhancement?.data?.time
}
`
const description = (enhancement) => `${
  enhancement?.name
} - ${
  enhancement?.data?.occasion
} (${
  enhancement?.data?.comment
}) - ${
  enhancement?.data?.date?.replace(',', '.')
} @ ${
  enhancement?.data?.time
}`

export default {summary, summaryShort, description}
